@if (hasShownItems) {
  <div class="context-menu-container" [ngClass]="{ 'context-menu-container--smaller': smaller }" #menuContainer>
    <button
      data-testid="context-menu-toggle"
      class="btn open-menu"
      type="button"
      (click)="toggle($event)"
      [style.visibility]="buttonVisible || isOpened ? 'visible' : 'hidden'"
      #menuButton
      >
      <span class="transparent-circle"></span>
      <span class="transparent-circle"></span>
      <span class="transparent-circle"></span>
    </button>
    @if (isOpened) {
      <div class="position-relative">
        <div class="menu-container" [ngClass]="{ right: !leftSide, up: openUpwards }">
          @if (!openUpwards) {
            <div class="arrow-container">
              <span class="top" [ngClass]="{ left: leftSide, right: !leftSide }"></span>
            </div>
          }
          <ul class="menu">
            @for (item of menuDefinition; track item) {
              @if (showItem(item)) {
                <li>
                  <button [attr.data-testid]="'context-menu-command-' + item.commandId" class="menu-item" type="button" (click)="onClicked(item, $event)" [disabled]="isDispatchingCommand">
                    {{ item.header | translate }}<i class="{{ item.icon }}"></i>
                  </button>
                </li>
              }
            }
          </ul>
          @if (openUpwards) {
            <div class="arrow-container">
              <span class="bottom" [ngClass]="{ left: leftSide, right: !leftSide }"></span>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
